import classNames from 'classnames';
import { ButtonHTMLAttributes, FC } from 'react';

import './_button.scss';

export enum ButtonKind {
    LINK = 'LINK',
    PRIMARY = 'PRIMARY',
    INVERT = 'INVERT',
    INVERT_GRAY = 'INVERT_GRAY',
}

export enum ButtonSize {
    FULL = 'FULL',
    LG = 'LG',
}

interface IProps {
    kind?: keyof typeof ButtonKind;
    size?: keyof typeof ButtonSize;
}

type Props = IProps & ButtonHTMLAttributes<HTMLButtonElement>;

const Button: FC<Props> = ({ kind = ButtonKind.PRIMARY, children, size = ButtonSize.LG, className, ...props }) => (
    <button
        className={classNames(`button button__${kind.toLowerCase()} button__${size.toLowerCase()}`, className)}
        {...props}
    >
        {children}
    </button>
);

export default Button;
